<template>
    <div class="brand-book-home h-screen w-screen pos-relative bg-default-5 overflow-hidden">
        <div
            class="h-full w-full"
            :style="{
                transition: 'opacity 750ms ease-in-out, transform 750ms ease-in-out',
                transform: `translateY(${!isActive ? -100 : 0}px) scale(${isActive ? 1 : 1.2})`,
                opacity: isActive ? 1 : 0,
            }"
        >
            <video
                autoplay
                muted
                loop
                playsinline
                class="pos-absolute pos-top"
                style="height: 100% !important; width: 100% !important; object-fit: cover"
            >
                <source
                    src="https://d7bs17jvh0vgc.cloudfront.net/brand-book/compressed.mp4"
                    type="video/mp4"
                />
                <source
                    src="https://d7bs17jvh0vgc.cloudfront.net/brand-book/compressed.webm"
                    type="video/webm"
                />
            </video>

            <div class="text-white text-center pos-absolute pos-center-x pos-bottom text-nowrap">
                <BrandBookChevronDown @click.native="$emit('go-next')" />
            </div>
        </div>
    </div>
</template>

<script>
    import BrandBookChevronDown from './BrandBookChevronDown';

    export default {
        name: 'BrandBookHomeHero',
        components: { BrandBookChevronDown },
        props: ['isActive'],
    };
</script>
